import { Settings } from 'luxon'

Settings.defaultLocale = 'es'